import styled from "styled-components";
import Colors from "../../global/color";

import { NavLink as RouterNavLink } from "react-router-dom";

const StyledDesktopHeader = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  flex-direction: column;
  flex: 1 1 auto;
  z-index: 99;
  position: relative;
`;

const StyledTagline = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 40px;
  background-color: #2c2c30;
  color: #ffffff;
  font-size: 14px;
  line-height: 12px;
  letter-spacing: 3px;
  font-family: FuturaPT-Demi;
`;

const StyledTaglineMobile = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 30px;
  background-color: #2c2c30;
  color: #ffffff;
  font-size: 12px;
  line-height: 24px;
  letter-spacing: 3px;
  font-family: FuturaPT-Demi;
`;

const StyledDesktopNavWrapper = styled.div`
  display: flex;
  box-sizing: border-box;
  flex-direction: row;
  width: 100%;
  margin: 0 auto;
  // padding: 20px 60px;
  box-shadow: ${({ showSecondaryNav }) =>
    showSecondaryNav ? "" : "0px 1px 2px rgba(0, 0, 0, 0.1);"}
  background-color: #ffffff;
  position: ${({ isSticky }) => (isSticky ? "fixed" : "relative")};
`;

const StyledWidthCtn = styled.div`
  display: flex;
  box-sizing: border-box;
  flex-direction: row;
  justify-content: ${({ isInMemoriamHost }) => (isInMemoriamHost ? "center" : "space-between")};
  align-items: center;
  width: 100%;
  margin: 0 auto;
  padding: 0px 60px;
  max-width: 1440px;
`;

const StyledDesktopLogo = styled(RouterNavLink)`
  cursor: pointer;
  padding: 21px 14px 21px 0px;

  img {
    height: 32px;
    display: block;
  }
`;

const StyledDesktopNav = styled.ul`
  list-style-type: none;
  padding: 0;
  text-align: center;
  position: relative;
  z-index: 1;
  display: flex;
  margin: 0px;
`;

const StyledDesktopNavItem = styled.li`
  display: flex;
  flex-direction: row;
  &:first-child {
    padding-left: 18px;
  }
  &:last-child {
    padding-right: 18px;
  }

  .active {
    border-bottom: 2px solid ${Colors.gold};
  }
`;

const StyledDesktopNavLink = styled(RouterNavLink)`
  text-decoration: none;
  font-size: 12px;
  line-height: 12px;
  font-family: "FuturaPT-Medium";
  letter-spacing: 3px;
  text-transform: uppercase;
  color: rgba(0, 0, 0, 0.65);
  margin: 0 18px;
  cursor: pointer;
  padding-top: 33px;
  padding-bottom: 33px;
  border: 2px solid transparent;
  &:hover {
    border-bottom: 2px solid ${Colors.gold};
  }
`;

const StyledDesktopSecondaryNavLink = styled(RouterNavLink)`
  text-decoration: none;
  font-size: 12px;
  line-height: 12px;
  font-family: "FuturaPT-Medium";
  letter-spacing: 3px;
  text-transform: uppercase;
  color: rgba(0, 0, 0, 0.65);
  margin: 0 25px;
  cursor: pointer;

  &:hover {
    color: #212121;
    font-weight: 600;
  }
`;

const StyledDesktopSecondaryNavItem = styled.li`
  // height: 18px;
  display: flex;
  flex-direction: row;
  &:first-child {
    padding-left: 18px;
  }
  &:last-child {
    padding-right: 18px;
  }

  .active {
    color: #212121;
    font-weight: 600;
  }
`;

const SpacerSecondary = styled.div`
  height: 55px;
  display: ${({ isSecondarySticky }) => (isSecondarySticky ? "block" : "none")};
`;

const Spacer = styled.div`
  height: 80px;
  display: ${({ isSticky }) => (isSticky ? "block" : "none")};
`;

const StyledDesktopSecondaryNav = styled.ul`
  position: ${({ isSecondarySticky }) =>
    isSecondarySticky ? "fixed" : "relative"};
  top: 0px;
  display: flex;
  justify-content: center;
  list-style-type: none;
  padding: 0;
  text-align: center;
  z-index: 2;
  background-color: #fafafa;
  margin: 0px;
  padding-top: 19px;
  padding-bottom: 19px;
  width: 100%;
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.1);
`;

const StyledMobileLogo = styled.a`
  display: inline-block;
  cursor: pointer;
  width: 21px;

  .active {
    color: ${Colors.gold};
  }

  img {
    display: block;
    height: 32px;
  }
`;

const StyledMobileLogoAmp = styled.a`
  display: inline-block;
  cursor: pointer;
  width: 21px;

  .active {
    color: ${Colors.gold};
  }

  img {
    display: block;
    height: 32px;
  }
`;

const StyledMobileLogoWrapper = styled.div``;

const StyledMobileLogoWrapperAmp = styled.div``;

const StyledHamburger = styled.div`
  margin-top: -10px;
`;

const StyledCloseMenu = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  min-height: 25px;
  border-bottom: 1px solid #4c4c4f;
  path:not(:first-child) {
    fill: #ffffff;
  }
  padding: 20px 20px;

  img {
    display: block;
    height: 32px;
  }
`;

const StyledMobileBelt = styled.div`
  align-items: center;
  display: flex;
  padding: 10px 20px;
  justify-content: ${({ isInMemoriamHost }) => (isInMemoriamHost ? "center" : "space-between")};
`;

const StyledMobileHeader = styled.div`
  padding: 0 !important;
  align-items: center;
  position: fixed;
  top: 0;
  z-index: 99;
  width: 100%;
  height: ${({ isHomepage }) => (isHomepage ? "80px" : "50px")};
  background: white;
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.1);
`;

const StyledMobileMenu = styled.div`
  position: fixed;
  z-index: 99;
  top: 0;
  left: 0;
  background: #000;
  height: 100vh;
  width: 100%;
  overflow-y: scroll;
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  box-sizing: border-box;
  transform: translateZ(0);
  -moz-transform: translatez(0);
  -ms-transform: translatez(0);
  -o-transform: translatez(0);
  -webkit-transform: translateZ(0);
  -webkit-overflow-scrolling: auto;
  transform: translate3d(0, 0, 0);
`;

const StyledMobileNav = styled.ul`
  list-style-type: none;
  padding: ${({ isMobile }) => (isMobile ? "20px" : "40px")};
  padding-bottom: 100px;
  width: 100%;
  box-sizing: border-box;
  margin: 0px;
`;

const StyledMobileNavItem = styled.li`
  .active {
    color: ${Colors.gold};
  }
`;

const StyledMobileNavLink = styled(RouterNavLink)`
  font-family: "FuturaPT-Medium";
  font-weight: 500;
  font-size: 24px;
  line-height: 30px;
  letter-spacing: 0.25px;
  text-transform: capitalize;
  color: #fff;
  text-decoration: none;
  cursor: pointer;
  &:hover {
    color: ${Colors.gold};
  }
  .active {
    color: ${Colors.gold};
  }
`;

const StyledMobileNavLinkSecondary = styled(RouterNavLink)`
  font-family: "FuturaPT-Medium";
  font-weight: 500;
  font-size: 12px;
  line-height: 12px;
  letter-spacing: 3px;
  text-transform: uppercase;
  color: #fff;
  text-decoration: none;
  cursor: pointer;
  &:hover {
    color: ${Colors.gold};
  }
  .active {
    color: ${Colors.gold};
  }
`;

const StyledMobileSearchItem = styled.div`
  button {
    background: none;
    border: none;
    color: rgba(0, 0, 0, 0.65);
    cursor: pointer;
    display: flex;
    margin: 0;
    padding: 0;
  }

  svg {
    margin-right: 6px;
  }

  [fill="#999999"] {
    fill: rgba(0, 0, 0, 0.65);;
  }
`;

const StyledDesktopSearchItem = styled.div`
  margin-left: auto;
  margin-right: 40px;

  button {
    background: none;
    border: none;
    color: rgba(0, 0, 0, 0.65);
    cursor: pointer;
    display: flex;
    font-family: "FuturaPT-Medium";
    letter-spacing: 3px;
    margin: 0;
    padding: 0;
    text-transform: uppercase;
  }

  svg {
    margin-right: 6px;
  }

  [fill="#999999"] {
    fill: rgba(0, 0, 0, 0.65);;
  }
`;

export {
  StyledDesktopHeader,
  StyledTagline,
  StyledDesktopLogo,
  StyledDesktopNav,
  StyledDesktopNavLink,
  StyledDesktopNavItem,
  StyledDesktopNavWrapper,
  StyledWidthCtn,
  StyledMobileBelt,
  StyledMobileHeader,
  StyledHamburger,
  StyledMobileMenu,
  StyledMobileNav,
  StyledMobileNavLink,
  StyledMobileNavItem,
  StyledCloseMenu,
  StyledMobileLogo,
  StyledMobileLogoAmp,
  StyledMobileLogoWrapper,
  StyledMobileLogoWrapperAmp,
  Spacer,
  StyledDesktopSecondaryNav,
  SpacerSecondary,
  StyledDesktopSecondaryNavItem,
  StyledDesktopSecondaryNavLink,
  StyledTaglineMobile,
  StyledMobileNavLinkSecondary,
  StyledMobileSearchItem,
  StyledDesktopSearchItem
};
